const doc = [({"SEO":({"title":"Privacy Policy", "description":"Leggi le politiche di rispetto della privacy e di protezione dei dati personali dell'agenzia immobiliare Dove.it"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;